var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"flex space-between mb-1 mb-4"},[_c('h1',{staticClass:"page-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("actions")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }